import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import List from "@mui/material/List";
import MainDrawerLogo from "./MainDrawerLogo";
import LeftSubNullMenu from "@layout/MainLayout/MainDrawer/LeftSubNullMenu";
import LeftSubMenu from "@layout/MainLayout/MainDrawer/LeftSubMenu";
import { useMenuState } from "@assets/contexts/MenuContext";

const MainDrawer = ({ onHome }) => {
  const value = useMenuState();
  let strArr = Object.values(value.menu);
  const location = useLocation();
  const [menus, setMenus] = useState(strArr);

  // subMenu 오픈  Function
  const handleMenuOpen = (num) => {
    const newData = menus.map((data) => {
      if (data.no === num) {
        data.open = !data.open;
      }
      return data;
    });
    setMenus(newData);
  };
  // url 데이터 가져오기
  const arr = location.pathname.split("/").filter((data, i) => i !== 0);
  return (
    <>
      <MainDrawerLogo onHome={onHome} />
      <List
        sx={{
          width: "100%",
          maxWidth: 360,
          bgcolor: "background.paper",
          p: 0,
          pl: 1,
          pr: 1,
        }}
        component="nav"
        aria-labelledby="nested-list-subheader"
      >
        {menus.map((data, index) => {
          return (
            <div key={data.no}>
              {data.permission && data.view ? (
                <>
                  {data.sub === null ? (
                    <LeftSubNullMenu arr={arr[0]} data={data} />
                  ) : (
                    <LeftSubMenu
                      arr={arr}
                      onClick={handleMenuOpen}
                      data={data}
                      onOpen={handleMenuOpen}
                    />
                  )}
                </>
              ) : (
                <></>
              )}
            </div>
          );
        })}
      </List>
    </>
  );
};

export default MainDrawer;
